import { Pipe, PipeTransform } from '@angular/core';

/**
 * Use this pipe to keep desired number values to XBS's standard Currency Conversion format.
 */

const CURRENCY_CONVERSION_ROUNDING = 6;

@Pipe({ name: 'xbsCurrencyConversionFormat' })
export class XbsCurencyConversionFormatPipe implements PipeTransform {

  constructor() { }

  transform(value: any): string {
    if (!value) {
      return '';
    }
    let formatted = Number(value).toFixed(CURRENCY_CONVERSION_ROUNDING);
    return formatted === 'NaN' ? value : formatted;
  }

}